module.exports = {"open":"열기","notice":"공지사항","more":"더보기","noNotice":"등록된 공지사항이 없습니다.","inquiry":"1:1 문의","noInquiry":"등록된 1:1 문의가 없습니다.","answered":"답변완료","checking":"확인중","event":"이벤트","version":"버전"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/mainboard.json
// module id = CJYT
// module chunks = 2